export default function ({ app }) {
  if (app.$auth.isAuthenticated) {
    app.$auth.logout()
  }
}
